const fromMergedPeriodResponseToClusterPeriod = mergedPeriodResponse => {
  const {
    startTimeUtcMillis,
    endTimeUtcMillis,
    isTrueStartTime,
    isTrueEndTime,
    periodStartOffsetMillis,
    periodEndOffsetMillis,
    overlappingPeriods
  } = mergedPeriodResponse;
  const clusterPeriod = {
    id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
    startEpoch: startTimeUtcMillis,
    endEpoch: endTimeUtcMillis,
    isTrueStartTime,
    isTrueEndTime,
    startOffset: periodStartOffsetMillis,
    endOffset: periodEndOffsetMillis,
    overlaps: overlappingPeriods.map(fromOverlappingPeriodResponseToOverlappingPeriod)
  };
  return clusterPeriod;
};
const fromOverlappingPeriodResponseToOverlappingPeriod = overlappingPeriodResponse => {
  const {
    startTimeUtcMillis,
    endTimeUtcMillis,
    periodStartOffsetMillis,
    periodEndOffsetMillis,
    overlappingRotations,
    isTrueStartTime,
    isTrueEndTime
  } = overlappingPeriodResponse;
  const overlappingPeriod = {
    id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
    startEpoch: startTimeUtcMillis,
    endEpoch: endTimeUtcMillis,
    startOffset: periodStartOffsetMillis,
    endOffset: periodEndOffsetMillis,
    overlaps: overlappingRotations,
    isTrueStartTime,
    isTrueEndTime
  };
  return overlappingPeriod;
};
export { fromMergedPeriodResponseToClusterPeriod };